(() => {
  if (customElements.get('er-collection-filters')) return;

  class ERCollectionFilters extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.dialog = this.querySelector('[data-er-dialog]');
      this.trigger = this.querySelector('[data-er-open]');
      this.form = this.querySelector('[data-er-form]');
      this.closeButton = this.querySelector('[data-er-close]');
      if (!this.dialog || !this.trigger || !this.form || !this.closeButton) return;
      if (typeof this.dialog.showModal !== 'function') return;
      const options = { signal: this.controller.signal };
      this.dialog.close();
      this.dataset.ready = '';
      this.trigger.hidden = false;
      this.closeButton.hidden = false;
      this.form.noValidate = true;
      this.syncLinks();
      this.trigger.addEventListener('click', () => this.open(), options);
      this.closeButton.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.afterClose(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.form.addEventListener('input', () => this.validatePrice(), options);
      this.form.addEventListener('change', () => {
        const inheritedSort = this.form.querySelector('[data-er-inherited-sort]');
        if (inheritedSort && this.form.querySelector('input[type="radio"][name="sort_by"]:checked')) inheritedSort.disabled = true;
      }, options);
      this.form.addEventListener('submit', (event) => {
        this.validatePrice();
        const invalidInput = this.form.querySelector(':invalid');
        if (invalidInput?.closest('details')) invalidInput.closest('details').open = true;
        if (!this.form.reportValidity()) {
          event.preventDefault();
          return;
        }
        this.preserveContext();
      }, options);
      this.form.addEventListener('formdata', (event) => {
        for (const [key, value] of [...event.formData.entries()]) {
          if (String(value).trim() === '' || key === 'page') event.formData.delete(key);
        }
      }, options);
      window.addEventListener('pageshow', () => {
        if (this.dialog.open) this.dialog.close();
        this.validatePrice();
        this.syncLinks();
      }, options);
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
      this.unlockScroll();
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      this.trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('er-collection-filter-open');
      this.closeButton.focus({ preventScroll: true });
    }

    afterClose() {
      this.trigger.setAttribute('aria-expanded', 'false');
      this.unlockScroll();
      if (this.isConnected) this.trigger.focus({ preventScroll: true });
    }

    unlockScroll() {
      if (!document.querySelector('er-collection-filters dialog:modal')) document.documentElement.classList.remove('er-collection-filter-open');
    }

    contextParameters() {
      return [...new URL(location.href).searchParams.entries()].filter(([key]) => !key.startsWith('filter.') && !['sort_by', 'page', 'section_id', 'sections', 'er_category', 'er_size', 'er_colour', 'er_availability', 'er_price_min', 'er_price_max'].includes(key));
    }

    preserveContext() {
      this.form.querySelectorAll('[data-er-preserved]').forEach((input) => input.remove());
      for (const [name, value] of this.contextParameters()) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        input.dataset.erPreserved = '';
        this.form.append(input);
      }
    }

    syncLinks() {
      for (const link of this.querySelectorAll('[data-er-clear], [data-er-remove]')) {
        const url = new URL(link.getAttribute('href'), location.origin);
        if (url.origin !== location.origin) continue;
        for (const [name, value] of this.contextParameters()) if (!url.searchParams.has(name)) url.searchParams.append(name, value);
        url.searchParams.delete('page');
        link.setAttribute('href', url.pathname + url.search + url.hash);
      }
    }

    validatePrice() {
      const minimum = this.form.querySelector('[data-er-price-min]');
      const maximum = this.form.querySelector('[data-er-price-max]');
      if (!minimum || !maximum) return;
      const invalid = minimum.value !== '' && maximum.value !== '' && Number(minimum.value) > Number(maximum.value);
      maximum.setCustomValidity(invalid ? maximum.dataset.erRangeError : '');
    }
  }

  customElements.define('er-collection-filters', ERCollectionFilters);
})();
